import { Component, EventListener, findComponents, GondelBaseComponent, GondelComponent } from '@gondel/core';
import {
	IValidatableInputComponent,
	ValidatableInputData,
} from '../../../../shared/utils/js/validatable-input.interface';
import { Checkbox } from '../../../atoms/checkbox/js/checkbox';

/**
 * checkbox module implementation.
 * @author Srdan Turudic <srdan.turudic@merkle.com>
 */

enum Selectors {
	InputCheckbox = '.js-m-checkbox__input',
	Group = '.js-m-checkbox-group',
	Hint = '.m-checkbox-group__hint',
}

enum States {
	Error = 'state-m-checkbox--error',
}

enum CustomDataAttributes {
	Required = 'data-required',
	Name = 'data-name',
}

@Component('CheckboxGroup')
export class CheckboxGroup extends GondelBaseComponent implements IValidatableInputComponent {
	private _inputCheckbox: HTMLInputElement = {} as HTMLInputElement;
	private _group: HTMLUListElement = {} as HTMLUListElement;

	private _hint: string = '';

	public start() {
		this._inputCheckbox = this._ctx.querySelector(Selectors.InputCheckbox) as HTMLInputElement;
		this._group = this._ctx.parentNode as HTMLUListElement;
		this._hint = this._ctx.querySelector(Selectors.Hint)?.innerHTML ?? '';
	}

	/**
	 * Handle click on custom box
	 */
	@EventListener('click')
	@EventListener('keyup')
	public _onClick(event: KeyboardEvent | Event): void {
		this._isValid();
	}

	/**
	 * Handle validation for single and grouped checkbox
	 */
	public _isValid() {
		if (this._ctx.getAttribute(CustomDataAttributes.Required) === null) {
			return true;
		}

		const components = findComponents(this._ctx, 'Checkbox');

		if (components.find((x) => (x as Checkbox)._inputCheckbox.checked) && this._ctx.classList.contains(States.Error)) {
			this._ctx.classList.remove(States.Error);
			// reset hint if it was a be validation error shown
			(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = this._hint;
			return true;
		} else if (
			!components.find((x) =>  (x as Checkbox)._inputCheckbox.checked) &&
			!this._ctx.classList.contains(States.Error)
		) {
			this._ctx.classList.add(States.Error);
			return false;
		}

		return !this._ctx.classList.contains(States.Error);
	}

	public getData(): ValidatableInputData {
		const checkboxes = findComponents<Checkbox>(this._ctx, 'Checkbox');
		const data = checkboxes.map((x) => x.getData()).filter((x) => x.additionalValue === true);

		return new ValidatableInputData(
			this._ctx.getAttribute(CustomDataAttributes.Name) ?? '',
			data.map((x) => x.value)
		);
	}

	public _showValidationErrorsByBe(data: any) {
		this._ctx.classList.add(States.Error);
		(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = data.errors.join(' ');
	}
}
